
<script setup>

import { ref } from 'vue'

import { useElementSize } from '@vueuse/core'

import { useRouter } from 'vue-router'

import Clouds from '../partials/clouds.vue'

import Header from '../partials/header.vue'

import Footer from '../partials/footer.vue'

import skylineUrl from 'url:../../images/skyline.png'

const header = ref( null )

const { height: headerHeight } = useElementSize( header )

const zipCodeInput = ref( null )

const router = useRouter()

const handleSubmit = () => router.push( { name: 'report', query: { 'zip-code': zipCodeInput.value } } )

</script>

<template>

  <Header ref="header" />

  <main class="relative overflow-hidden min-h-screen bg-linear-to-r from-[#45C5E3] to-[#BFD630]" :style="{ minHeight: `calc(100vh - ${headerHeight}px)` }" >

    <div class="absolute inset-x-0 bottom-0 flex justify-center overflow-hidden">

      <img :src="skylineUrl" class="w-full min-w-6xl mix-blend-multiply object-cover" />

    </div>

    <div>

      <Clouds />

    </div>

    <div class="max-w-screen-xl mx-auto z-50">

      <div class="text-white flex flex-col items-center text-center gap-6 lg:gap-10 py-24 lg:py-36 px-6 sm:px-8">

        <h1 class="text-4xl md:text-5xl lg:text-6xl font-bold z-50">

          See Local Health Trends in Seconds

        </h1>

        <p class="text-xl lg:text-2xl z-50">

          Enter your ZIP code below to get your custom health report.

        </p>

        <form @submit.prevent="handleSubmit">

          <div class="flex">

            <div class="relative">

              <input 

                v-model="zipCodeInput" name="zipCode" type="text" pattern="^\d{5}$" maxlength="5" placeholder="" required 

                class="bg-white pl-5 w-full peer h-12 pt-4 text-sm sm:mr-16 text-neutral-700 border border-gray-300 rounded-l-full focus:outline-none focus:ring-2 focus:border-blue-500 focus:ring-blue-500 z-50" />

              <label

                for="zipCode"

                class="pl-3 text-sm sm:text-base flex items-center absolute top-0 left-0 h-12 mx-3 text-neutral-400 pointer-events-none origin-top-left transform -translate-y-1 scale-75 transition-transform peer-placeholder-shown:translate-y-0 peer-placeholder-shown:scale-100 peer-focus:-translate-y-1 peer-focus:scale-75 whitespace-nowrap">

                Enter your ZIP code

              </label>

            </div>

            <button type="submit" class="bg-[#0A7FEB] text-sm sm:text-lg font-bold px-2 sm:px-6 h-12 rounded-r-full flex items-center justify-center z-50 hover:cursor-pointer">

              View Report

            </button>

          </div>

        </form>

      </div>

    </div>

  </main>

  <Footer />

</template>